import styled from 'styled-components';

import { ReactComponent as CloseSvg } from '../../../../../../../../assets/close_icon.svg';

interface Props {
  label: string;
  isActive: boolean;
  onChange: (isActive: boolean) => void;
}

const BooleanFilter: React.FC<Props> = ({ label, isActive, onChange }) => {
  return (
    <FilterContainer $isActive={isActive}>
      <Background $isActive={isActive} />
      <Label $isActive={isActive}>{label}</Label>
      {isActive ? <CloseIcon /> : null}
      <Checkbox
        type="checkbox"
        checked={isActive}
        onChange={(event) => onChange(event.target.checked)}
      />
    </FilterContainer>
  );
};

const Checkbox = styled.input`
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
`;

const FilterContainer = styled.span.attrs<{ $isActive: boolean }>((props) => ({
  $isActive: props.$isActive ?? false,
}))`
  position: relative;
  border: 1px solid
    ${(props) =>
      props.$isActive ? 'var(--action-color)' : 'var(--border-color)'};
  transition: border-color 0.4s ease;
  border-radius: 4px;
  padding: 6px 13px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Background = styled.div.attrs<{ $isActive: boolean }>((props) => ({
  $isActive: props.$isActive ?? false,
}))`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${(props) =>
    props.$isActive ? 'var(--action-color)' : 'transparent'};
  opacity: 0.15;
  transition: background-color 0.4s ease;
`;

const Label = styled.label.attrs<{ $isActive: boolean }>((props) => ({
  $isActive: props.$isActive ?? false,
}))`
  color: ${(props) =>
    props.$isActive ? 'var(--action-color)' : 'var(--font-color)'};
  transition: color 0.4s ease;
  white-space: nowrap;
`;

const CloseIcon = styled(CloseSvg)`
  overflow: visible;
  height: 20px;
  width: 20px;
  padding-top: 3px;
  margin-left: 8px;

  path {
    stroke: var(--action-color);
  }
`;

export default BooleanFilter;
